import axios from "axios"

export function getToken(tokenKey?:string){
  switch (tokenKey) {
    //49Rs
    case 'd6a2':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5LCJpYXQiOjE3NDg5NDA3MjN9.e-6_iQjdLWc-2K2DlOL4fYNB-IuyA4OwlU5_y2M3YuY', discountedPrice:'49'}
    //99Rs.
    case '293o':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjk5LCJpYXQiOjE3NDg5NDA3NTF9.VS06EB_Wx2kBYwvJpNc0rUqNmh0XgtluSuFpdJDJPNk', discountedPrice:'99'}
    //199Rs.
    case 'l1y3':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjE5OSwiaWF0IjoxNzQ4OTQwNzY4fQ.PExsPj0QxU8EKWdgtPUyM-dYyNEhtgmzZ7bgaK84tZg', discountedPrice:'199'}
    //299Rs.
    case '892g':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjI5OSwiaWF0IjoxNzQ4OTQwNzk2fQ.zuFaI02KWaGb8PdoPwj_Q6ePQNwZEPCWozt5IE-Agv4', discountedPrice:'299'}
    //499Rs.
    case '909g':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5OSwiaWF0IjoxNzQ5MzkyNDE4fQ.5AkknoBCGa0bQdD7USn9FOFHO4Vka3hPZb9i0UMahSk', discountedPrice:'499'}
    //999Rs.
    case 'hut2':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjk5OSwiaWF0IjoxNzUzODgzMzAxfQ.OVhtmIBvLSUtJh9FKYisuoCuQ5CLiApPBOBUFkUzrRo', discountedPrice:'999'}

    default:
      return null;
  }
}

export async function getMasterClassDataWithAbTest(id:string,abTestType:string,fetchBxBatchWa?:boolean){
  
  const res = await axios.get(
    `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/landing-page/${id}?abtest=true&abtesttype=${abTestType}&fetchBxBatchWa=${!!fetchBxBatchWa}`,
    {
      headers: {
        "Accept-Encoding": "gzip",
      },
    }
  );
console.log("data",JSON.stringify(res.data,null,2))
  return res;
  
}
export async function getMasterClassData(id:string){
  
    const res = await axios.get(
       `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/landing-page/${id}`,
       {
         headers: {
           "Accept-Encoding": "gzip",
         },
       }
     );
    return res;
}

export async function getBootcampData(id:string){

    const res = await axios.get(
       `${process.env.NEXT_PUBLIC_BASE_API}bootcamps/landing-page/${id}`,
       {
         headers: {
           "Accept-Encoding": "gzip",
         },
       }
     );
    return res;
}
